export default __webpack_public_path__ + "static/media/1.e12f76a3.jpg";